<template>
  <div class="page-shell">
    <v-list subheader two-line>
      <v-card class="page-toolbar" flat>
        <b-row>
          <b-col cols="3">
            <v-text-field label="Digite o que busca" placeholder="Não informado" outlined dark hide-details="auto"
              v-model="text_busca"></v-text-field>
          </b-col>
          <b-col cols="2">
            <v-btn block x-large @click="carregaAvisos(text_busca)">
              <v-icon>mdi-check-circle-outline</v-icon>&nbsp; Buscar
            </v-btn>
          </b-col>
          <b-col cols="2">
            <v-btn block x-large @click="NovoAviso()">
              <v-icon>mdi-check-circle-outline</v-icon>&nbsp; Novo
            </v-btn>
          </b-col>
        </b-row>
      </v-card></v-list>
    <b-row>
      <b-col cols="8"></b-col>
      <b-col cols="4">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
      </b-col>
    </b-row>
    <v-data-table :headers="headers" :items="lst_avisos" :search="search" fixed-header :disable-pagination="true"
      height="500px"
      hide-default-footer>
      <template v-slot:item.status="{ item }">
        <div>
          <v-btn icon @click="EditAviso(item)">
            <v-icon>mdi-tag-edit</v-icon>
          </v-btn>
          <v-btn icon @click="EmailAviso(item)">
            <v-icon>mdi-email-check</v-icon>
          </v-btn>
          <v-btn icon @click="DeleteAviso(item)">
            <v-icon>mdi-delete-empty</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="modal_aviso" max-width="1200" scrollable transition="dialog-top-transition">
      <v-card>
        <v-card-title>
          <b-row>
            <b-col cols="10">Avisos </b-col>
            <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
              <v-btn @click="modal_aviso = false" text icon x-large>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </b-col>
          </b-row>
        </v-card-title>
        <v-card-text style="max-height: 900px">
          <b-container fluid>
            <b-row :style="{ paddingTop: '10px' }">
              <b-col cols="6">
                <v-text-field label="Autor" placeholder="Autor" outlined v-model="aviso.autor"
                  hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <v-text-field label="Descrição" placeholder="Não informado" outlined v-model="aviso.descricao"
                  hide-details="auto"></v-text-field>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-editor v-model="aviso.texto" id="editorChamado"></vue-editor>
              </b-col>
            </b-row>
          </b-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="SalvarAviso" color="grey darken-4" dark block>
            <v-icon>mdi-content-save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import Vue from "vue";
import Avisos from "../domain/Avisos";
import _Enum from "../obj/Enum";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  data: () => ({
    Enum: _Enum,
    lst_avisos: [],
    search: "",
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: true,
        value: "id",
      },
      {
        text: "Descrição",
        align: "start",
        sortable: true,
        value: "descricao",
      },
      {
        text: "Autor",
        align: "start",
        sortable: true,
        value: "autor",
      },
      {
        text: "Data",
        align: "start",
        sortable: true,
        value: "datac",
      },
      {
        text: "",
        align: "start",
        sortable: true,
        value: "status",
      },
    ],
    text_busca: "",
    modal_aviso: false,
    estrutura_aviso: {
      id: '',
      autor: '',
      descricao: '',
      texto: '',
      datac: '',
      horac: '',
      tag: ''
    },
    aviso: {},
    oper: ''
  }),

  mounted() {
    this.carregaAvisos("");
  },
  methods: {
    carregaAvisos(filtro) {
      Vue.Loading("", "", this);
      this.service = new Avisos(this.$resource);
      this.service.get(filtro).then(
        function (tmp) {
          this.lst_avisos = tmp;
          console.log(this.lst_avisos);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );
    },
    getID(val) {

      if (val.id == "cliente") {
        console.log(val.dados);
        this.cliente = val.value;
        this.cnpj = val.dados.cnpj;
        this.empresa = val.dados.empresa;
      }
    },

    NovoAviso() {
      this.aviso = JSON.parse(JSON.stringify(this.estrutura_aviso));
      this.modal_aviso = true;
      this.oper = "I";
    },
    EditAviso(i) {

      i.texto = Vue.atob(i.texto);
      this.aviso = i;
      this.modal_aviso = true;
      this.oper = "A";

    },
    EmailAviso(i) {

      Vue.Loading("", "", this);
      this.service = new Avisos(this.$resource);
      this.service.sendEmail("", i.id).then(
        function (tmp) {
          var vm = this;
          setTimeout(()=>{
            Vue.CloseLoading(vm);
          },2000)
          
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );



    },
    DeleteAviso(i) {

      Vue.Loading("", "", this);
      this.service = new Avisos(this.$resource);
      this.service.delete(i.id).then(
        function (tmp) {
          this.carregaAvisos(this.text_busca);
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );

    },
    SalvarAviso() {
      var vm = this;
      // vm, title, content, callSim, callNao
      if (this.aviso.descricao == "") {
        Vue.Mensagem(vm, "Descrição", "Preencha o campo descrição");
        return;
      }
      if (this.aviso.texto == "") {
        Vue.Mensagem(vm, "AVISO", "Preencha o campo aviso");
        return;
      }

      var rdata = [{
        id: this.aviso.id,
        descricao: this.aviso.descricao,
        texto: Vue.btoa(this.aviso.texto),
        datac: Vue.getData(),
        horac: Vue.getHora(),
        autor: this.aviso.autor,
        tag: this.aviso.tag

      }]


      Vue.Loading("", "", this);
      this.service = new Avisos(this.$resource);
      this.service.save(rdata).then(
        function (tmp) {
          this.modal_aviso = false;
          this.carregaAvisos("");
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          console.log(err);
        }
      );

    },
  },
};
</script>
<style lang="">
</style>
